import { Box, Typography } from '@mui/material'
import React from 'react'
import { useTranslate } from 'react-admin'

const FieldRow = ({ icon, children, helperText }) => {
  let IconElement = null
  const translate = useTranslate()

  if (React.isValidElement(icon)) {
    // Already instantiated JSX element (<CircularGaugeIcon … />)
    IconElement = icon
  } else if (icon && (typeof icon === 'function' || typeof icon === 'object')) {
    // Component reference (MUI icons like TodayIcon, LocationOnIcon, etc.)
    const IconComp = icon
    IconElement = <IconComp fontSize="small" sx={{ color: '#444' }} />
  }
  return (
    <Box sx={{ flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            backgroundColor: '#f5f5f5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          {IconElement}
        </Box>
        <Box sx={{ fontSize: '0.9rem', color: '#222', fontWeight: 500 }}>{children}</Box>
      </Box>
      {helperText && (
        <Typography variant="body3" sx={{ color: '#999', fontWeight: 500 }}>
          {translate(helperText)}
        </Typography>
      )}
    </Box>
  )
}

export default FieldRow
